import axios from 'axios';

export const reportDispatchApi = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND!}api/report-dispatch`,
});